import React, { TextareaHTMLAttributes } from 'react';
import { STextArea } from '../../styles/components/TextArea';
import { validateField } from '../../utils/validateField';

type TextAreaType = TextareaHTMLAttributes<HTMLTextAreaElement>;

const TextArea = (props: TextAreaType) => {

    const validate = (e: HTMLTextAreaElement) => {
        const validation = validateField(e);
        validation();
    }

    return (
        <STextArea {...props}
            onBlur={(e) => validate(e.currentTarget)}
            onSubmit={(e) => validate(e.currentTarget)}
        >

        </STextArea>
    );
}

export default TextArea;